<!-- Truncated display-->
<ng-container *ngIf="truncate">
  <div class="highlighted-topline highlighted-topline--social">
    <div *ngIf="topline?.appliedToplineValue"
         class="truncate">
      <span class="pr-0025">
        <i *ngIf="!topline?.appliedToplineValue"
           class="fal fal fa-link-horizontal"></i>
        <i *ngIf="topline?.appliedToplineValue"
           class="{{getSocialIconClass(topline?.appliedToplineValue?.socialNetwork?.id)}}"></i>
      </span>

      <a *ngIf="topline?.appliedToplineValue && !isBad()"
         style="text-overflow:ellipsis;white-space: nowrap;"
         target="_blank"
         (click)="$event?.stopImmediatePropagation()"
         [attr.href]="getSocialURL(topline.appliedToplineValue?.socialNetwork?.id,topline.appliedToplineValue?.profile)"
         class="link link--noline color--gray--005 txt-fw-500">{{topline.appliedToplineValue.profile}}
      </a>

      <span *ngIf="topline?.appliedToplineValue && isBad()"
            style="text-overflow:ellipsis"
            class="color--gray--007 txt-fw-500">
        {{topline.appliedToplineValue.profile}}
      </span>
      <i class="far fa-check pair__verified ml-0025"
         *ngIf="topline.appliedToplineValue?.status === 'verified'"
         [matTooltip]="'Confirmed'"></i>

      <i class="far fa-times-circle pair__red ml-0050"
         *ngIf="topline.appliedToplineValue?.status === 'bad'"
         [matTooltip]="'Marked as Bad'"
         [matTooltipPosition]="'left'"></i>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!truncate">
  <div class="toplines__pair toplines__pair--social col__ flexAlign--baseline"
       [ngClass]="{'toplines__pair--empty':!topline?.appliedToplineValue}">
    <div class="pair__icon">
      <i *ngIf="!topline?.appliedToplineValue"
         class="fal fal fa-link-horizontal"></i>
      <i *ngIf="topline?.appliedToplineValue"
         class="{{getSocialIconClass(topline?.appliedToplineValue?.socialNetwork?.id)}}"></i>
    </div>

    <div class="pair__content truncate">
      <span *ngIf="!topline?.appliedToplineValue"
            (click)="onAddClicked()"
            class="pair__link link link--noline">
        Add {{ topline.toplineItem.itemId | propercase }}
      </span>
      <a *ngIf="topline?.appliedToplineValue && !isBad()"
         target="_blank"
         [attr.href]="getSocialURL(topline.appliedToplineValue?.socialNetwork?.id,topline.appliedToplineValue?.profile)"
         class="pair__link link link--noline link--black">{{topline.appliedToplineValue.profile}}
        <i class="far fa-check pair__verified"
           *ngIf="topline.appliedToplineValue?.status === 'verified'"
           [matTooltip]="'Confirmed'"
           [matTooltipPosition]="'left'"></i>
      </a>

      <a *ngIf="topline?.appliedToplineValue && isBad()"
         target="_blank"
         [attr.href]="getSocialURL(topline.appliedToplineValue?.socialNetwork?.id,topline.appliedToplineValue?.profile)"
         class="pair__link color--gray--007">{{topline.appliedToplineValue.profile}}
        <i class="far fa-check pair__verified"
           *ngIf="topline.appliedToplineValue?.status === 'verified'"
           [matTooltip]="'Confirmed'"
           [matTooltipPosition]="'left'"></i>
      </a>

      <i class="far fa-times-circle pair__red ml-0050"
         *ngIf="topline.appliedToplineValue?.status === 'bad'"
         [matTooltip]="'Marked as Bad'"
         [matTooltipPosition]="'left'"></i>
    </div>
  </div>
</ng-container>
